import { GrupoService } from "../../../services/GrupoService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import GrupoForm from "../../../components/forms/GrupoForm.vue";

export default {
    name: "EditarGrupo",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    components: {
        Breadcrumb,
        GrupoForm,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Grupos',
                disabled: false,
                href: '/gerenciar-grupos',
            },
            {
                text: 'Editar Grupo',
                disabled: true
            }
        ],
        grupoData: {},
        loading: false,
    }),
    created() {
        this.carregarGrupo(this.$route.params.id);
    },
    methods: {
        async handleSave(formData) {
            try {
                this.loading = true;
                
                // Converter dados do formulário para FormData
                const postData = new FormData();
                postData.append("exercicio", formData.exercicio);
                postData.append("codigo_grupo", formData.codigo_grupo);
                postData.append("descricao", formData.descricao);
                postData.append("ativo", formData.ativo ? 1 : 0);

                // Atualizar o grupo
                const response = await GrupoService.update(this.$route.params.id, postData);
                
                if (response) {
                    // Redirecionar para a listagem
                    this.$router.push('/gerenciar-grupos');
                } else {
                    throw new Error('Erro ao atualizar grupo');
                }
            } catch (error) {
                console.error('Erro ao atualizar grupo:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-grupos');
        },
        
        async carregarGrupo(id) {
            try {
                const response = await GrupoService.show(id);

                if (response) {
                    const data = response.data;
                    this.grupoData = data;
                } else {
                    console.error('Não foi possível carregar os dados do grupo.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados do grupo:', error);
            }
        }
    }
};
